module.exports = __webpack_public_path__ + "static/media/Nunito-LightItalic.25df6384.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/Nunito/Nunito-LightItalic.ttf
// module id = 305
// module chunks = 0